import React from 'react';
import { Link } from 'react-router-dom';
import Sidebar from '../mendepartmentdetails/Sidebar';
import SubDeptImage from '../../../assets/image/department/man-handshaking-his-employer-new-office-job_23-2149034566.jpg';

function VeteransJobTraining() {
  return (
    <section className="department-details-section">
      <div className="container">
        <div className="row">

          {/* Sidebar */}
          <div className="col-12 col-lg-4 col-xl-4">
            <Sidebar />
          </div>

          {/* Main Content */}
          <div className="col-lg-8">
            <div className="department-details-imgbox">
              <img src={SubDeptImage} className="img-fluid" alt="Employment and Job Training Programs for Veterans" />
            </div>

            <div className="department-details-content-box">
              <h4 className="department-details-title">Employment and Job Training Programs for Veterans</h4>
              <p>
                This sub-department is dedicated to supporting veterans in their transition to civilian careers through specialized employment and job training programs.<br />
                Services include career counseling, resume workshops, and partnerships with employers to provide meaningful job opportunities for veterans.<br /><br />
                By equipping veterans with the skills and resources needed for employment, we aim to foster economic stability and personal growth.
              </p>
            </div>

            <div className="department-details-benefits-box">
              <h3>Key Services</h3>
              <ul className="list-unstyled list-style">
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Career Counseling and Guidance</h5>
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Professional Skills Training</h5>
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Employer Partnerships for Job Placement</h5>
                </li>
              </ul>
            </div>

            <div className="department-details-policy-box">
              <h4>Our Commitment:</h4>
              <p>
                We are committed to providing veterans with the tools and opportunities they need to thrive in their professional lives, ensuring a successful transition to the civilian workforce.
              </p>
            </div>
            <div>
              <Link to="/department/veterans">
                <i className="fa-solid fa-circle-arrow-left" style={{ marginRight: '5px' }} />
                Go Back
              </Link>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

export default VeteransJobTraining;
